import { CSSProperties } from 'react'

export const containerStyle: CSSProperties = {
  padding: '0 30px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  fontSize: 14,
  width: 600
}

export const sectionStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 10
}

export const gridStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  rowGap: 10,
  columnGap: 10,
  padding: 5
}

export const columnRowStyle: CSSProperties = {
  fontSize: 14,
  display: 'flex',
  alignItems: 'flex-start',
  gap: 5
}

export const dropdownContentStyle: CSSProperties = {
  fontSize: 14
}

export const dropdownWrapperStyle: CSSProperties = {
  width: 'fit-content'
}

export const dropdownOuterStyle: CSSProperties = {
  minWidth: 150
}

export const footerStyle: CSSProperties = {
  padding: 30
}

export const exportButtonStyle: CSSProperties = {
  width: '100%'
}
